<ng-template #template>
    <div [class]="itemCssClasses" #container>
        <div class="svc-toolbox__category-separator" *ngIf="item.needSeparator && !creator.toolbox.showCategoryTitles">
        </div>
        <div class="svc-toolbox__tool-content sv-action__content" (pointerdown)="model.onPointerDown($event)">
            <ng-template [component]="{ name: model.itemComponent, default: 'svc-toolbox-item', 
            data: { model: item, viewModel: model, creator: creator, isCompact: isCompact } }"></ng-template>
        </div>
    </div>
</ng-template>